/**
 * WordPress dependencies
 */
import { Button } from '@wordpress/components';
import { Fragment, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

export default ({ notes }) => {
	const [showNotes, setShowNotes] = useState(true);

	return (
		<div className="wporg-chart-block__notes">
			{notes.length > 0 && (
				<Fragment>
					<Button
						className="wporg-chart-block__notes__toggle"
						onClick={() => setShowNotes(!showNotes)}
                        isLink={true}
					>
						{showNotes
							? __('Hide notes', 'wporg-block')
							: __('Show notes', 'wporg-block')}
					</Button>
					{showNotes && (
						<ul>
							{notes.map((note) => (
								<li key={note}>{note}</li>
							))}
						</ul>
					)}
				</Fragment>
			)}
		</div>
	);
};
